import Layout from '../components/Layout'
import SectionHeader from '../components/SectionHeader'
import ContactCard from '../components/ContactCard'

function Contact() {
  return (
    <Layout>
      <div className="pt-40 pb-32 md:pb-0 h-full">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-10">
          <div className="lg:w-2/3">
            <SectionHeader
              subtitle="CONTACT ME"
              title="Let's create something <br /> amazing together."
            />

            <div className="mt-10 max-w-2xl">
              <p className="text-lg text-gray-600 mb-12">
                I'm always open to discussing new projects, creative ideas, or
                opportunities to be part of your vision. Feel free to reach out
                if you're looking for a developer, have a question, or just want
                to connect.
              </p>

              <div className="space-y-4 mb-12">
                <div className="flex items-start">
                  <div className="text-xl mr-4">✓</div>
                  <div>Unity game development projects</div>
                </div>
                <div className="flex items-start">
                  <div className="text-xl mr-4">✓</div>
                  <div>React & TypeScript collaborations</div>
                </div>
                <div className="flex items-start">
                  <div className="text-xl mr-4">✓</div>
                  <div>Creative coding experiments</div>
                </div>
                <div className="flex items-start">
                  <div className="text-xl mr-4">✗</div>
                  <div>Spam</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:pt-40 lg:w-1/3">
            <div className="flex flex-col gap-4">
              <ContactCard
                href="https://github.com/nikseell"
                label="GitHub"
                value="github.com/nikseell"
                icon={<i className="devicon-github-original text-xl"></i>}
              />

              <ContactCard
                href="https://linkedin.com/in/niklavs-laicans"
                label="LinkedIn"
                value="linkedin.com/in/niklavs-laicans"
                icon={<i className="devicon-linkedin-plain text-xl"></i>}
              />

              <ContactCard
                href="mailto:niklavs.laicans@gmail.com"
                label="Email"
                value="niklavs.laicans@gmail.com"
                icon={<i className="devicon-google-plain text-xl"></i>}
                isExternal={false}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Contact
